<!--
 * @Author: aisi
 * @Date: 2020-01-04 09:44:40
 * @LastEditTime : 2020-01-06 18:44:46
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/views/analyseWord/studySurvey/CourseAverage.vue
 -->
<template>
  <div>
    <van-row class="layout">
      <van-col span="6" v-for="(item, index) in postList" :key="index">
        <van-row type="flex">
          <van-col span="3" class="desc">
            <span class="dian"></span>
          </van-col>
          <van-col span="21">
            <div>
              <p class="tit">{{ item.name }}</p>
              <p v-for="(rs, key) in item.data" :key="key">
                <span class="desc">{{ rs.tit }}：</span>
                <span class="stress">{{ rs.value }}</span>
              </p>
              <!-- <p>
                <span class="desc">满分：</span>
                <span>120</span>
              </p>-->
            </div>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
    <!-- <van-row class="layout topline">
      <van-col span="6" v-for="(item, index) in 10" :key="index">
        <van-row type="flex">
          <van-col span="3" class="desc">
            <span class="dian"></span>
          </van-col>
          <van-col span="21">
            <div>
              <p class="tit">A+组分析</p>
              <p>
                <span class="desc">均分：</span>
                <span class="stress">84.99</span>
              </p>
              <p>
                <span class="desc">满分：</span>
                <span>120</span>
              </p>
            </div>
          </van-col>
        </van-row>
      </van-col>
    </van-row>-->
  </div>
</template>
<script>
export default {
  props: ['postList']
}
</script>
<style lang="scss" scoped>
.layout {
  font-size: 14px;
  padding: 15px;
  > .van-col {
    margin: 7px 0;
  }
  .dian {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: #00c1de;
    border-radius: 10px;
    margin-top: 7px;
  }
  .tit {
    font-weight: bold;
  }
  .desc {
    color: #9ea7b4;
  }
  p {
    line-height: 1.75;
  }
}
.topline {
  border-top: 1px dashed #dcdee2;
}
</style>
